<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { setToCodeUrl } from '@/utils/config';
import { getUrlCode } from '@/utils/util';
import { getStore, removeStore, setStore, clearStore } from '@/utils/store';
import { getToken } from '@/utils/auth.js';

export default {
  name: 'App',
  watch: {
    $route: {
      handler(val, oldVal) {
        this.index++;
        if (this.index === 1) {
          this.$nextTick(()=>{
            this.login();
          })
        }
        // if (oldVal.query.secondaryRollback && val.name === null) {
        //   // 二次回退问题
        //   wx.closeWindow();
        // }
      },
      deep: true,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    getUrlCode,
    login() {
      const code = this.getUrlCode().code;
      // let redirect_uri = encodeURIComponent(
      //   `${safetyUrl}${this.$route.fullPath}?secondaryRollback=true`
      // );

      // let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=http://192.168.0.109:1888/&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
      if (code) {
        // this.$store.dispatch('Login', { wxLoginCode: code }).then((res) => {});
      } else {
        window.location.href = setToCodeUrl(`/login?redirect=${this.$route.fullPath}`);
      }
    },
  },
  mounted() {
    // const that = this;
    // window.addEventListener('popstate', function(state) {
    //   alert(JSON.stringify(state))
    // });
    // window.addEventListener(
    //   'popstate',
    //   function(e) {
    //     console.log('popstate::',window.location.href);
    //     if(that.$route.query.secondaryRollback){
    //       wx.closeWindow();
    //     }
    //   },
    //   false
    // );
  },
};
</script>

<style lang="scss">
html,
body,
#app {
  width: 100%;
  margin: 0;
  padding: 0;
  // height: 100%;
  // overflow: hidden;
}

ul {
  margin: 0;
  padding: 0;
}

.dis-flex {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.dis-y-flex {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.flex-x-center {
  -webkit-justify-content: center;
  justify-content: center;
  -moz-box-pack: center;
  -webkit--moz-box-pack: center;
  box-pack: center;
}
.flex-x-between {
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -moz-box-pack: space-between;
  -webkit--moz-box-pack: space-between;
  box-pack: space-between;
}

.flex-x-end {
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  -moz-box-pack: flex-end;
  -webkit--moz-box-pack: flex-end;
  box-pack: flex-end;
}

.flex-y-center {
  align-items: center;
  -webkit-align-items: center;
  box-align: center;
  -moz-box-align: center;
  -webkit-box-align: center;
}

.f-w-w {
  -webkit-flex-wrap: wrap;
  -webkit-box-lines: multiple;
  -moz-flex-wrap: wrap;
  flex-wrap: wrap;
}

.t-o-e {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clear:after {
  content: ' ';
  display: block;
  height: 0;
  clear: both;
}

.cursor-p {
  cursor: pointer;
}
.van-button--warning {
  background-color: #fb5913 !important;
  border: 1px solid #fb5913 !important;
}
.all-van-uploader {
  .van-uploader__upload {
    background-color: #d7d7d7;
  }
  .van-uploader__upload-icon {
    color: #ffffff;
  }
}
.van-cell__title {
  color: #000 !important;
}
// 表单start

.van-field__label {
  color: #000 !important;
}
.el-input__inner {
  border-color: #7c7c7c !important;
}
.el-input__inner,
.van-field__control {
  color: #000 !important;
  &::-webkit-input-placeholder {
    color: #7c7c7c !important;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */

    color: #7c7c7c !important;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */

    color: #7c7c7c !important;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #7c7c7c !important;
  }
}

// 表单end
</style>
